<mono-common-footer>
  <ng-container main>
    <div class="flex-container align-middle align-left margin-bottom-1">
      <img
        class="footer__learn-my-way-logo"
        src="assets/images/learn-my-way-logo.png"
        alt="Learn My Way logo"
        width="100%"
        height="100%"
      />
      <strong
        class="small"
        >{{ (footerCms | async)?.data?.attributes?.from }}</strong
      >
      <a href="https://goodthingsfoundation.org" rel="noopener" target="_blank"
        ><img
          class="footer__good-things-logo"
          src="assets/images/good-things-logo.svg"
          alt="Good Things Foundation logo"
          width="100%"
          height="100%"
      /></a>
    </div>
    <p class="margin-bottom-1-5"
    >
    {{ (footerCms | async)?.data?.attributes?.description }}
    </p>
  </ng-container>
  <ng-container switcher>
    <div  class="flex-container align-right align-bottom height-100 padding-bottom-1-5">
      <a *ngIf="locale == 'en-gb'" class="button clear button--icon-on-left height-auto font-large" href="https://www.wales.learnmyway.com/" rel="noferrer">
          <svg class="icon icon--welsh-dragon icon--primary margin-right-0-5">
          <use xlink:href="#icon-welsh-dragon" href="#icon-welsh-dragon"></use>
          </svg> Newidiwch i'r fersiwn Gymraeg
      </a>
      <a *ngIf="locale == 'cy-gb'" class="button clear button--icon-on-right height-auto font-large padding-right-0" href="https://learnmyway.com" rel="noferrer">
        Switch to the English site <svg class="icon icon--swap icon--material margin-left-0-5">
          <use xlink:href="#icon-swap" href="#icon-swap"></use>
          </svg>
      </a>
    </div>
  </ng-container>
  <ng-container linkList>
    <li>
      <a
        routerLinkActive="active no-underline"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/', privacyPageLink]"
        >{{ (footerCms | async)?.data?.attributes?.privacyLink }}</a
      >
    </li>
    <li *ngIf="loadCookies">
      <a
        routerLinkActive="active no-underline"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/', cookiesPageLink]"
        >{{ (footerCms | async)?.data?.attributes?.cookiesLink }}</a
      >
    </li>
    <li>
      <a
        routerLinkActive="active no-underline"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/', termsAndConditionsPageLink]"
        >{{ (footerCms | async)?.data?.attributes?.termsAndConditionsLink }}</a
      >
    </li>
    <li>
      <a
        routerLinkActive="active no-underline"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/', accessibilityPageLink]"
        >{{ (footerCms | async)?.data?.attributes?.accessibilityLink }}</a
      >
    </li>
    <li>
      <a
        routerLinkActive="active no-underline"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/', reportAnIssuePageLink]"
        >{{ (footerCms | async)?.data?.attributes?.reportAnIssueLink }}</a
      >
    </li>
  </ng-container>
</mono-common-footer>
